import { useParams } from 'react-router-dom'

import './styles.scss'

import ChatList from 'features/ChatList/ChatList'
import Chat from 'features/Chat/Chat'
import cn from 'classnames'

const Chats = () => {
  const { id } = useParams()

  return (
    <div className={cn('chats-grid', { 'open-chat': !!id })}>
      <div className="chats-grid__list column">
        <ChatList />
      </div>
      <div className="chats-grid__chat">
        {id ? <Chat id={id} /> : <Chat.Empty />}
      </div>
    </div>
  )
}

export default Chats
